import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import {betMoney, isGuest} from 'app/utils';
import PrizeCard from 'app/components/reusable/PrizeCard';
import {type ParamsInterface} from 'app/utils/Get';
import {modalConfirm} from 'app/utils/modals/popups';
import {artifactName} from 'app/components/my_profile/artifacts/utils';
import {openAuth} from 'app/components/auth/auth';
import UserInventoryLink from 'app/helpers/UserInventoryLink';
import {marketplaceOrderController} from 'app/controllers/shop/marketplaceOrderController';
import MarketplaceOrderInterface from 'app/interfaces/MarketplaceOrderInterface';
import RecipeInterface from 'app/interfaces/RecipeInterface';

export interface OrderProps extends MarketplaceOrderInterface {
    query: ParamsInterface
    recipe: RecipeInterface
    restrict_artifact: boolean
}

const Order = ({
    artifact,
    ask_user,
    id,
    price,
    query,
    recipe,
    restrict_artifact,
    self_order
}: OrderProps): React.ReactElement => {
    const disableButton = Boolean(self_order || restrict_artifact);
    const {avatar_url, name, public_inventory} = ask_user;

    const handleBuy = useCallback(() => {
        if (isGuest()) {
            openAuth();
            return;
        }

        if (disableButton) {
            return;
        }

        modalConfirm(I18n.t('buy_artifact_confirm', {artifact: artifactName(artifact)}), () => {
            marketplaceOrderController.buy(id, query);
        });
    }, [
        artifact,
        disableButton,
        id,
        query
    ]);

    return <div className="market-details__item">
        <div className="market-details__item__name-seller">
            <div className="market-details__item--img-wrap">
                <div className="market-details__item--img market-item-card">
                    <PrizeCard artifact={artifact} hideMeta hideName/>
                </div>
            </div>
            <div className="market-details__item--desc-seller">
                <div className="market-details__item--desc">
                    <div className="market-details__item--desc-title">
                        {artifactName(recipe)}
                    </div>
                </div>
                <div className="market-details__item__seller">
                    <span className="mobile-label">{I18n.t('seller')}:</span>
                    <span className="field-value">
                        <UserInventoryLink
                            user_nickname={name}
                            public_inventory={public_inventory}
                            profile_image={avatar_url}
                            show_profile_image
                        />
                    </span>
                </div>
            </div>
        </div>
        <div className="market-details__item__price-actions">
            <div className="market-details__item__price-value">{betMoney({amount: price})}</div>
            <div className="market-details__item__actions">
                <button
                    className={`btn${disableButton ? ' btn--disable' : ''}`}
                    disabled={disableButton}
                    onClick={handleBuy}
                >{I18n.t('buy_now')}</button>
            </div>
        </div>
    </div>;
};

export default Order;
